// Auto-generated image imports
// Generated on: 2025-12-22T08:32:49.999Z

import { Setting, setting } from '@bz/request';

import betlimitexceededCombo_1 from '../BZimg/Beslipimg/Combo/BetlimitexceededBakosBlue.png';
import betlimitexceededCombo_0 from '../BZimg/Beslipimg/Combo/BetlimitexceededCoolBlack.png';
import betlimitexceededCombo_2 from '../BZimg/Beslipimg/Combo/BetlimitexceededPlaster.png';
import devprogressCombo_1 from '../BZimg/Beslipimg/Combo/DevProgressBakosBlue.png';
import devprogressCombo_0 from '../BZimg/Beslipimg/Combo/DevProgressCoolBlack.png';
import devprogressCombo_2 from '../BZimg/Beslipimg/Combo/DevProgressPlaster.png';
import marketisnotavailableCombo_1 from '../BZimg/Beslipimg/Combo/MarketisnotavailableBakosBlue.png';
import marketisnotavailableCombo_0 from '../BZimg/Beslipimg/Combo/MarketisnotavailableCoolBlack.png';
import marketisnotavailableCombo_2 from '../BZimg/Beslipimg/Combo/MarketisnotavailablePlaster.png';
import networkerrorFailure_1 from '../BZimg/Beslipimg/Failure/NetworkerrorBakosBlue.png';
import networkerrorFailure_0 from '../BZimg/Beslipimg/Failure/NetworkerrorCoolBlack.png';
import networkerrorFailure_2 from '../BZimg/Beslipimg/Failure/NetworkerrorPlaster.png';
import timeoutFailure_1 from '../BZimg/Beslipimg/Failure/TimeoutBakosBlue.png';
import timeoutFailure_0 from '../BZimg/Beslipimg/Failure/TimeoutCoolBlack.png';
import timeoutFailure_2 from '../BZimg/Beslipimg/Failure/TimeoutPlaster.png';
import bzcomGeneral_1 from '../BZimg/Beslipimg/General/bzcomBakosBlue.png';
import bzcomGeneral_0 from '../BZimg/Beslipimg/General/bzcomCoolBlack.png';
import bzcomGeneral_2 from '../BZimg/Beslipimg/General/bzcomPlaster.png';
import emptyGeneral_1 from '../BZimg/Beslipimg/General/EmptyBakosBlue.png';
import emptyGeneral_0 from '../BZimg/Beslipimg/General/EmptyCoolBlack.png';
import emptyGeneral_2 from '../BZimg/Beslipimg/General/EmptyPlaster.png';
import loadingGeneral_1 from '../BZimg/Beslipimg/General/LoadingBakosBlue.png';
import loadingGeneral_0 from '../BZimg/Beslipimg/General/LoadingCoolBlack.png';
import loadingGeneral_2 from '../BZimg/Beslipimg/General/LoadingPlaster.png';
import successGeneral_1 from '../BZimg/Beslipimg/General/SuccessBakosBlue.png';
import successGeneral_0 from '../BZimg/Beslipimg/General/SuccessCoolBlack.png';
import successGeneral_2 from '../BZimg/Beslipimg/General/SuccessPlaster.png';
import partialsuccessSingle_1 from '../BZimg/Beslipimg/Single/PartialsuccessBakosBlue.png';
import partialsuccessSingle_0 from '../BZimg/Beslipimg/Single/PartialsuccessCoolBlack.png';
import partialsuccessSingle_2 from '../BZimg/Beslipimg/Single/PartialsuccessPlaster.png';
import favouritesemptyEmptyimg_1 from '../BZimg/img/Emptyimg/FavouritesEmptyBakosBlue.png';
import favouritesemptyEmptyimg_0 from '../BZimg/img/Emptyimg/FavouritesEmptyCoolBlack.png';
import favouritesemptyEmptyimg_2 from '../BZimg/img/Emptyimg/FavouritesEmptyPlaster.png';
import generalemptyEmptyimg_1 from '../BZimg/img/Emptyimg/GeneralEmptyBakosBlue.png';
import generalemptyEmptyimg_0 from '../BZimg/img/Emptyimg/GeneralEmptyCoolBlack.png';
import generalemptyEmptyimg_2 from '../BZimg/img/Emptyimg/GeneralEmptyPlaster.png';
import mybetsemptyEmptyimg_1 from '../BZimg/img/Emptyimg/MyBetsEmptyBakosBlue.png';
import mybetsemptyEmptyimg_0 from '../BZimg/img/Emptyimg/MyBetsEmptyCoolBlack.png';
import mybetsemptyEmptyimg_2 from '../BZimg/img/Emptyimg/MyBetsEmptyPlaster.png';
import failureimgGeneralStatusimg_1 from '../BZimg/img/GeneralStatusimg/FailureimgBakosBlue.png';
import failureimgGeneralStatusimg_0 from '../BZimg/img/GeneralStatusimg/FailureimgCoolBlack.png';
import failureimgGeneralStatusimg_2 from '../BZimg/img/GeneralStatusimg/FailureimgPlaster.png';
import failureGeneraltipsimg from '../BZimg/img/GeneralStatusimg/Generaltipsimg/Failure.png';
import reconfirmGeneraltipsimg from '../BZimg/img/GeneralStatusimg/Generaltipsimg/Reconfirm.png';
import reviewGeneraltipsimg from '../BZimg/img/GeneralStatusimg/Generaltipsimg/Review.png';
import successGeneraltipsimg from '../BZimg/img/GeneralStatusimg/Generaltipsimg/Success.png';
import loadingimgGeneralStatusimg_1 from '../BZimg/img/GeneralStatusimg/LoadingimgBakosBlue.png';
import loadingimgGeneralStatusimg_0 from '../BZimg/img/GeneralStatusimg/LoadingimgCoolBlack.png';
import loadingimgGeneralStatusimg_2 from '../BZimg/img/GeneralStatusimg/LoadingimgPlaster.png';
import reviewimgGeneralStatusimg_1 from '../BZimg/img/GeneralStatusimg/ReviewimgBakosBlue.png';
import reviewimgGeneralStatusimg_0 from '../BZimg/img/GeneralStatusimg/ReviewimgCoolBlack.png';
import reviewimgGeneralStatusimg_2 from '../BZimg/img/GeneralStatusimg/ReviewimgPlaster.png';
import successimgGeneralStatusimg_1 from '../BZimg/img/GeneralStatusimg/SuccessimgBakosBlue.png';
import successimgGeneralStatusimg_0 from '../BZimg/img/GeneralStatusimg/SuccessimgCoolBlack.png';
import successimgGeneralStatusimg_2 from '../BZimg/img/GeneralStatusimg/SuccessimgPlaster.png';
import crownSection1_1 from '../BZimg/img/Section1/CrownBakosBlue.png';
import crownSection1_0 from '../BZimg/img/Section1/CrownCoolBlack.png';
import crownSection1_2 from '../BZimg/img/Section1/CrownPlaster.png';
import linkSection1_1 from '../BZimg/img/Section1/linkBakosBlue.png';
import linkSection1_0 from '../BZimg/img/Section1/linkCoolBlack.png';
import linkSection1_2 from '../BZimg/img/Section1/linkPlaster.png';
import paakeySection1_1 from '../BZimg/img/Section1/PaakeyBakosBlue.png';
import paakeySection1_0 from '../BZimg/img/Section1/PaakeyCoolBlack.png';
import paakeySection1_2 from '../BZimg/img/Section1/PaakeyPlaster.png';
import safesuccessSection1_1 from '../BZimg/img/Section1/SafeSuccessBakosBlue.png';
import safesuccessSection1_0 from '../BZimg/img/Section1/SafeSuccessCoolBlack.png';
import safesuccessSection1_2 from '../BZimg/img/Section1/SafeSuccessPlaster.png';
import safewarningSection1_1 from '../BZimg/img/Section1/SafeWarningBakosBlue.png';
import safewarningSection1_0 from '../BZimg/img/Section1/SafeWarningCoolBlack.png';
import safewarningSection1_2 from '../BZimg/img/Section1/SafeWarningPlaster.png';
import img40440X_1 from '../BZimg/SystemEnvironmentAnomaliesimg/40X/404BakosBlue.png';
import img40440X_0 from '../BZimg/SystemEnvironmentAnomaliesimg/40X/404CoolBlack.png';
import img40440X_2 from '../BZimg/SystemEnvironmentAnomaliesimg/40X/404Plaster.png';
import img40840X_1 from '../BZimg/SystemEnvironmentAnomaliesimg/40X/408BakosBlue.png';
import img40840X_0 from '../BZimg/SystemEnvironmentAnomaliesimg/40X/408CoolBlack.png';
import img40840X_2 from '../BZimg/SystemEnvironmentAnomaliesimg/40X/408Plaster.png';
import img50050X_1 from '../BZimg/SystemEnvironmentAnomaliesimg/50X/500BakosBlue.png';
import img50050X_0 from '../BZimg/SystemEnvironmentAnomaliesimg/50X/500CoolBlack.png';
import img50050X_2 from '../BZimg/SystemEnvironmentAnomaliesimg/50X/500Plaster.png';
import img50250X_1 from '../BZimg/SystemEnvironmentAnomaliesimg/50X/502BakosBlue.png';
import img50250X_0 from '../BZimg/SystemEnvironmentAnomaliesimg/50X/502CoolBlack.png';
import img50250X_2 from '../BZimg/SystemEnvironmentAnomaliesimg/50X/502Plaster.png';
import img50350X_1 from '../BZimg/SystemEnvironmentAnomaliesimg/50X/503BakosBlue.png';
import img50350X_0 from '../BZimg/SystemEnvironmentAnomaliesimg/50X/503CoolBlack.png';
import img50350X_2 from '../BZimg/SystemEnvironmentAnomaliesimg/50X/503Plaster.png';
import img50450X_1 from '../BZimg/SystemEnvironmentAnomaliesimg/50X/504BakosBlue.png';
import img50450X_0 from '../BZimg/SystemEnvironmentAnomaliesimg/50X/504CoolBlack.png';
import img50450X_2 from '../BZimg/SystemEnvironmentAnomaliesimg/50X/504Plaster.png';
import devprogressOthers_1 from '../BZimg/SystemEnvironmentAnomaliesimg/Others/DevProgressBakosBlue.png';
import devprogressOthers_0 from '../BZimg/SystemEnvironmentAnomaliesimg/Others/DevProgressCoolBlack.png';
import devprogressOthers_2 from '../BZimg/SystemEnvironmentAnomaliesimg/Others/DevProgressPlaster.png';
import notinserviceareaOthers_1 from '../BZimg/SystemEnvironmentAnomaliesimg/Others/NotinServiceAreaBakosBlue.png';
import notinserviceareaOthers_0 from '../BZimg/SystemEnvironmentAnomaliesimg/Others/NotinServiceAreaCoolBlack.png';
import notinserviceareaOthers_2 from '../BZimg/SystemEnvironmentAnomaliesimg/Others/NotinServiceAreaPlaster.png';
import soccerBakosBlue from '../BZimg/Outright/001-Soccer/BakosBlue.png';
import soccerCoolBlack from '../BZimg/Outright/001-Soccer/CoolBlack.png';
import soccerPlaster from '../BZimg/Outright/001-Soccer/Plaster.png';
import basketballBakosBlue from '../BZimg/Outright/002-Basketball/BakosBlue.png';
import basketballCoolBlack from '../BZimg/Outright/002-Basketball/CoolBlack.png';
import basketballPlaster from '../BZimg/Outright/002-Basketball/Plaster.png';
import baseballBakosBlue from '../BZimg/Outright/003-Baseball/BakosBlue.png';
import baseballCoolBlack from '../BZimg/Outright/003-Baseball/CoolBlack.png';
import baseballPlaster from '../BZimg/Outright/003-Baseball/Plaster.png';
import iceHockeyBakosBlue from '../BZimg/Outright/004-IceHockey/BakosBlue.png';
import iceHockeyCoolBlack from '../BZimg/Outright/004-IceHockey/CoolBlack.png';
import iceHockeyPlaster from '../BZimg/Outright/004-IceHockey/Plaster.png';
import tennisBakosBlue from '../BZimg/Outright/005-Tennis/BakosBlue.png';
import tennisCoolBlack from '../BZimg/Outright/005-Tennis/CoolBlack.png';
import tennisPlaster from '../BZimg/Outright/005-Tennis/Plaster.png';
import handballBakosBlue from '../BZimg/Outright/006-Handball/BakosBlue.png';
import handballCoolBlack from '../BZimg/Outright/006-Handball/CoolBlack.png';
import handballPlaster from '../BZimg/Outright/006-Handball/Plaster.png';
import golfBakosBlue from '../BZimg/Outright/009-Golf/BakosBlue.png';
import golfCoolBlack from '../BZimg/Outright/009-Golf/CoolBlack.png';
import golfPlaster from '../BZimg/Outright/009-Golf/Plaster.png';
import rugbyBakosBlue from '../BZimg/Outright/012-Rugby/BakosBlue.png';
import rugbyCoolBlack from '../BZimg/Outright/012-Rugby/CoolBlack.png';
import rugbyPlaster from '../BZimg/Outright/012-Rugby/Plaster.png';
import aussieRulesBakosBlue from '../BZimg/Outright/013-AussieRules/BakosBlue.png';
import aussieRulesCoolBlack from '../BZimg/Outright/013-AussieRules/CoolBlack.png';
import aussieRulesPlaster from '../BZimg/Outright/013-AussieRules/Plaster.png';
import bandyBakosBlue from '../BZimg/Outright/015-Bandy/BakosBlue.png';
import bandyCoolBlack from '../BZimg/Outright/015-Bandy/CoolBlack.png';
import bandyPlaster from '../BZimg/Outright/015-Bandy/Plaster.png';
import americanFootballBakosBlue from '../BZimg/Outright/016-AmericanFootball/BakosBlue.png';
import americanFootballCoolBlack from '../BZimg/Outright/016-AmericanFootball/CoolBlack.png';
import americanFootballPlaster from '../BZimg/Outright/016-AmericanFootball/Plaster.png';
import cyclingBakosBlue from '../BZimg/Outright/017-Cycling/BakosBlue.png';
import cyclingCoolBlack from '../BZimg/Outright/017-Cycling/CoolBlack.png';
import cyclingPlaster from '../BZimg/Outright/017-Cycling/Plaster.png';
import specialsBakosBlue from '../BZimg/Outright/018-Specials/BakosBlue.png';
import specialsCoolBlack from '../BZimg/Outright/018-Specials/CoolBlack.png';
import specialsPlaster from '../BZimg/Outright/018-Specials/Plaster.png';
import cricketBakosBlue from '../BZimg/Outright/021-Cricket/BakosBlue.png';
import cricketCoolBlack from '../BZimg/Outright/021-Cricket/CoolBlack.png';
import cricketPlaster from '../BZimg/Outright/021-Cricket/Plaster.png';
import dartsBakosBlue from '../BZimg/Outright/022-Darts/BakosBlue.png';
import dartsCoolBlack from '../BZimg/Outright/022-Darts/CoolBlack.png';
import dartsPlaster from '../BZimg/Outright/022-Darts/Plaster.png';
import volleyballBakosBlue from '../BZimg/Outright/023-Volleyball/BakosBlue.png';
import volleyballCoolBlack from '../BZimg/Outright/023-Volleyball/CoolBlack.png';
import volleyballPlaster from '../BZimg/Outright/023-Volleyball/Plaster.png';
import waterpoloBakosBlue from '../BZimg/Outright/026-Waterpolo/BakosBlue.png';
import waterpoloCoolBlack from '../BZimg/Outright/026-Waterpolo/CoolBlack.png';
import waterpoloPlaster from '../BZimg/Outright/026-Waterpolo/Plaster.png';
import curlingBakosBlue from '../BZimg/Outright/028-Curling/BakosBlue.png';
import curlingCoolBlack from '../BZimg/Outright/028-Curling/CoolBlack.png';
import curlingPlaster from '../BZimg/Outright/028-Curling/Plaster.png';
import futsalBakosBlue from '../BZimg/Outright/029-Futsal/BakosBlue.png';
import futsalCoolBlack from '../BZimg/Outright/029-Futsal/CoolBlack.png';
import futsalPlaster from '../BZimg/Outright/029-Futsal/Plaster.png';
import olympicsBakosBlue from '../BZimg/Outright/030-Olympics/BakosBlue.png';
import olympicsCoolBlack from '../BZimg/Outright/030-Olympics/CoolBlack.png';
import olympicsPlaster from '../BZimg/Outright/030-Olympics/Plaster.png';
import lacrosseBakosBlue from '../BZimg/Outright/039-Lacrosse/BakosBlue.png';
import lacrosseCoolBlack from '../BZimg/Outright/039-Lacrosse/CoolBlack.png';
import lacrossePlaster from '../BZimg/Outright/039-Lacrosse/Plaster.png';
import formulaBakosBlue from '../BZimg/Outright/040-Formula/BakosBlue.png';
import formulaCoolBlack from '../BZimg/Outright/040-Formula/CoolBlack.png';
import formulaPlaster from '../BZimg/Outright/040-Formula/Plaster.png';
import alpineSkiingBakosBlue from '../BZimg/Outright/043-AlpineSkiing/BakosBlue.png';
import alpineSkiingCoolBlack from '../BZimg/Outright/043-AlpineSkiing/CoolBlack.png';
import alpineSkiingPlaster from '../BZimg/Outright/043-AlpineSkiing/Plaster.png';
import biathlonBakosBlue from '../BZimg/Outright/044-Biathlon/BakosBlue.png';
import biathlonCoolBlack from '../BZimg/Outright/044-Biathlon/CoolBlack.png';
import biathlonPlaster from '../BZimg/Outright/044-Biathlon/Plaster.png';
import crossCountryBakosBlue from '../BZimg/Outright/046-Cross-Country/BakosBlue.png';
import crossCountryCoolBlack from '../BZimg/Outright/046-Cross-Country/CoolBlack.png';
import crossCountryPlaster from '../BZimg/Outright/046-Cross-Country/Plaster.png';
import skiJumpingBakosBlue from '../BZimg/Outright/048-SkiJumping/BakosBlue.png';
import skiJumpingCoolBlack from '../BZimg/Outright/048-SkiJumping/CoolBlack.png';
import skiJumpingPlaster from '../BZimg/Outright/048-SkiJumping/Plaster.png';
import eSportCounterStrikeBakosBlue from '../BZimg/Outright/109-ESportCounter-Strike/BakosBlue.png';
import eSportCounterStrikeCoolBlack from '../BZimg/Outright/109-ESportCounter-Strike/CoolBlack.png';
import eSportCounterStrikePlaster from '../BZimg/Outright/109-ESportCounter-Strike/Plaster.png';
import eSportDotaBakosBlue from '../BZimg/Outright/111-ESportDota/BakosBlue.png';
import eSportDotaCoolBlack from '../BZimg/Outright/111-ESportDota/CoolBlack.png';
import eSportDotaPlaster from '../BZimg/Outright/111-ESportDota/Plaster.png';
import eSportCallOfDutyBakosBlue from '../BZimg/Outright/118-ESportCallofDuty/BakosBlue.png';
import eSportCallOfDutyCoolBlack from '../BZimg/Outright/118-ESportCallofDuty/CoolBlack.png';
import eSportCallOfDutyPlaster from '../BZimg/Outright/118-ESportCallofDuty/Plaster.png';
import speedwayBakosBlue from '../BZimg/Outright/131-Speedway/BakosBlue.png';
import speedwayCoolBlack from '../BZimg/Outright/131-Speedway/CoolBlack.png';
import speedwayPlaster from '../BZimg/Outright/131-Speedway/Plaster.png';
import gaelicFootballBakosBlue from '../BZimg/Outright/135-GaelicFootball/BakosBlue.png';
import gaelicFootballCoolBlack from '../BZimg/Outright/135-GaelicFootball/CoolBlack.png';
import gaelicFootballPlaster from '../BZimg/Outright/135-GaelicFootball/Plaster.png';
import gaelicHurlingBakosBlue from '../BZimg/Outright/136-GaelicHurling/BakosBlue.png';
import gaelicHurlingCoolBlack from '../BZimg/Outright/136-GaelicHurling/CoolBlack.png';
import gaelicHurlingPlaster from '../BZimg/Outright/136-GaelicHurling/Plaster.png';
import stockCarRacingBakosBlue from '../BZimg/Outright/191-StockCarRacing/BakosBlue.png';
import stockCarRacingCoolBlack from '../BZimg/Outright/191-StockCarRacing/CoolBlack.png';
import stockCarRacingPlaster from '../BZimg/Outright/191-StockCarRacing/Plaster.png';
import eSportValorantBakosBlue from '../BZimg/Outright/194-ESportValorant/BakosBlue.png';
import eSportValorantCoolBlack from '../BZimg/Outright/194-ESportValorant/CoolBlack.png';
import eSportValorantPlaster from '../BZimg/Outright/194-ESportValorant/Plaster.png';
import emptyEmptyimg_1 from '../BZimg/img/Emptyimg/EmptyBakosBlue.png';
import emptyEmptyimg_0 from '../BZimg/img/Emptyimg/EmptyCoolBlack.png';
import emptyEmptyimg_2 from '../BZimg/img/Emptyimg/EmptyPlaster.png';
import Credit1 from '../BZimg/Wallet/Credit1.png';
import Credit2 from '../BZimg/Wallet/Credit2.png';
import Credit3 from '../BZimg/Wallet/Credit3.png';
import BetBack from '../BZimg/Vip/BetBack.png';
import DedicatedHost from '../BZimg/Vip/DedicatedHost.png';
import MilestoneCash from '../BZimg/Vip/MilestoneCash.png';
import MonthlyRestock from '../BZimg/Vip/MonthlyRestock.png';
import ActionDrop from '../BZimg/Vip/ActionDrop.png';
import WeeklyEdge from '../BZimg/Vip/WeeklyEdge.png';
import Hero from '../BZimg/Vip/Hero.png';
import Bronze from '../BZimg/Vip/Bronze.png';
import Silver from '../BZimg/Vip/Silver.png';
import Gold from '../BZimg/Vip/Gold.png';
import Platinum from '../BZimg/Vip/Platinum.png';
import Diamond from '../BZimg/Vip/Diamond.png';
import Obsidian from '../BZimg/Vip/Obsidian.png';
import Init from '../BZimg/Vip/Init.png';
import UnlockActionDrop from '../BZimg/Vip/UnlockActionDrop.png';
import UnlockBetBack from '../BZimg/Vip/UnlockBetBack.png';
import UnlockDedicatedHost from '../BZimg/Vip/UnlockDedicatedHost.png';
import UnlockMilestoneCash from '../BZimg/Vip/UnlockMilestoneCash.png';
import UnlockMonthlyRestock from '../BZimg/Vip/UnlockMonthlyRestock.png';
import UnlockWeeklyEdge from '../BZimg/Vip/UnlockWeeklyEdge.png';
import HeroMaskBG from '../BZimg/Vip/HeroMaskBG.png';
import FaqCoolBlack01 from '../BZimg/Wallet/FaqCoolBlack01.png';
import FaqBakosBlue01 from '../BZimg/Wallet/FaqBakosBlue01.png';
import FaqPlaster01 from '../BZimg/Wallet/FaqPlaster01.png';
import FaqCoolBlack02 from '../BZimg/Wallet/FaqCoolBlack02.png';
import FaqBakosBlue02 from '../BZimg/Wallet/FaqBakosBlue02.png';
import FaqPlaster02 from '../BZimg/Wallet/FaqPlaster02.png';
import FaqCoolBlack03 from '../BZimg/Wallet/FaqCoolBlack03.png';
import FaqBakosBlue03 from '../BZimg/Wallet/FaqBakosBlue03.png';
import FaqPlaster03 from '../BZimg/Wallet/FaqPlaster03.png';
import FaqCoolBlack04 from '../BZimg/Wallet/FaqCoolBlack04.png';
import FaqBakosBlue04 from '../BZimg/Wallet/FaqBakosBlue04.png';
import FaqPlaster04 from '../BZimg/Wallet/FaqPlaster04.png';
import { matchDetailThemeAssets } from './matchDetail';

import { SportIdMap } from '~/constants';
// Theme-based assets mapping
export const themeAssets = {
  betlimitexceededCombo: {
    [Setting.Theme.bakos]: betlimitexceededCombo_1,
    [Setting.Theme.cool]: betlimitexceededCombo_0,
    [Setting.Theme.plaster]: betlimitexceededCombo_2,
  },
  devprogressCombo: {
    [Setting.Theme.bakos]: devprogressCombo_1,
    [Setting.Theme.cool]: devprogressCombo_0,
    [Setting.Theme.plaster]: devprogressCombo_2,
  },
  marketisnotavailableCombo: {
    [Setting.Theme.bakos]: marketisnotavailableCombo_1,
    [Setting.Theme.cool]: marketisnotavailableCombo_0,
    [Setting.Theme.plaster]: marketisnotavailableCombo_2,
  },
  networkerrorFailure: {
    [Setting.Theme.bakos]: networkerrorFailure_1,
    [Setting.Theme.cool]: networkerrorFailure_0,
    [Setting.Theme.plaster]: networkerrorFailure_2,
  },
  timeoutFailure: {
    [Setting.Theme.bakos]: timeoutFailure_1,
    [Setting.Theme.cool]: timeoutFailure_0,
    [Setting.Theme.plaster]: timeoutFailure_2,
  },
  bzcomGeneral: {
    [Setting.Theme.bakos]: bzcomGeneral_1,
    [Setting.Theme.cool]: bzcomGeneral_0,
    [Setting.Theme.plaster]: bzcomGeneral_2,
  },
  emptyGeneral: {
    [Setting.Theme.bakos]: emptyGeneral_1,
    [Setting.Theme.cool]: emptyGeneral_0,
    [Setting.Theme.plaster]: emptyGeneral_2,
  },
  loadingGeneral: {
    [Setting.Theme.bakos]: loadingGeneral_1,
    [Setting.Theme.cool]: loadingGeneral_0,
    [Setting.Theme.plaster]: loadingGeneral_2,
  },
  successGeneral: {
    [Setting.Theme.bakos]: successGeneral_1,
    [Setting.Theme.cool]: successGeneral_0,
    [Setting.Theme.plaster]: successGeneral_2,
  },
  partialsuccessSingle: {
    [Setting.Theme.bakos]: partialsuccessSingle_1,
    [Setting.Theme.cool]: partialsuccessSingle_0,
    [Setting.Theme.plaster]: partialsuccessSingle_2,
  },
  favouritesemptyEmptyimg: {
    [Setting.Theme.bakos]: favouritesemptyEmptyimg_1,
    [Setting.Theme.cool]: favouritesemptyEmptyimg_0,
    [Setting.Theme.plaster]: favouritesemptyEmptyimg_2,
  },
  generalemptyEmptyimg: {
    [Setting.Theme.bakos]: generalemptyEmptyimg_1,
    [Setting.Theme.cool]: generalemptyEmptyimg_0,
    [Setting.Theme.plaster]: generalemptyEmptyimg_2,
  },
  mybetsemptyEmptyimg: {
    [Setting.Theme.bakos]: mybetsemptyEmptyimg_1,
    [Setting.Theme.cool]: mybetsemptyEmptyimg_0,
    [Setting.Theme.plaster]: mybetsemptyEmptyimg_2,
  },
  failureimgGeneralStatusimg: {
    [Setting.Theme.bakos]: failureimgGeneralStatusimg_1,
    [Setting.Theme.cool]: failureimgGeneralStatusimg_0,
    [Setting.Theme.plaster]: failureimgGeneralStatusimg_2,
  },
  failureGeneraltipsimg: {
    [Setting.Theme.cool]: failureGeneraltipsimg,
    [Setting.Theme.bakos]: failureGeneraltipsimg,
    [Setting.Theme.plaster]: failureGeneraltipsimg,
  },
  reconfirmGeneraltipsimg: {
    [Setting.Theme.cool]: reconfirmGeneraltipsimg,
    [Setting.Theme.bakos]: reconfirmGeneraltipsimg,
    [Setting.Theme.plaster]: reconfirmGeneraltipsimg,
  },
  reviewGeneraltipsimg: {
    [Setting.Theme.cool]: reviewGeneraltipsimg,
    [Setting.Theme.bakos]: reviewGeneraltipsimg,
    [Setting.Theme.plaster]: reviewGeneraltipsimg,
  },
  successGeneraltipsimg: {
    [Setting.Theme.cool]: successGeneraltipsimg,
    [Setting.Theme.bakos]: successGeneraltipsimg,
    [Setting.Theme.plaster]: successGeneraltipsimg,
  },
  loadingimgGeneralStatusimg: {
    [Setting.Theme.bakos]: loadingimgGeneralStatusimg_1,
    [Setting.Theme.cool]: loadingimgGeneralStatusimg_0,
    [Setting.Theme.plaster]: loadingimgGeneralStatusimg_2,
  },
  reviewimgGeneralStatusimg: {
    [Setting.Theme.bakos]: reviewimgGeneralStatusimg_1,
    [Setting.Theme.cool]: reviewimgGeneralStatusimg_0,
    [Setting.Theme.plaster]: reviewimgGeneralStatusimg_2,
  },
  successimgGeneralStatusimg: {
    [Setting.Theme.bakos]: successimgGeneralStatusimg_1,
    [Setting.Theme.cool]: successimgGeneralStatusimg_0,
    [Setting.Theme.plaster]: successimgGeneralStatusimg_2,
  },
  crownSection1: {
    [Setting.Theme.bakos]: crownSection1_1,
    [Setting.Theme.cool]: crownSection1_0,
    [Setting.Theme.plaster]: crownSection1_2,
  },
  linkSection1: {
    [Setting.Theme.bakos]: linkSection1_1,
    [Setting.Theme.cool]: linkSection1_0,
    [Setting.Theme.plaster]: linkSection1_2,
  },
  paakeySection1: {
    [Setting.Theme.bakos]: paakeySection1_1,
    [Setting.Theme.cool]: paakeySection1_0,
    [Setting.Theme.plaster]: paakeySection1_2,
  },
  safesuccessSection1: {
    [Setting.Theme.bakos]: safesuccessSection1_1,
    [Setting.Theme.cool]: safesuccessSection1_0,
    [Setting.Theme.plaster]: safesuccessSection1_2,
  },
  safewarningSection1: {
    [Setting.Theme.bakos]: safewarningSection1_1,
    [Setting.Theme.cool]: safewarningSection1_0,
    [Setting.Theme.plaster]: safewarningSection1_2,
  },
  img40440X: {
    [Setting.Theme.bakos]: img40440X_1,
    [Setting.Theme.cool]: img40440X_0,
    [Setting.Theme.plaster]: img40440X_2,
  },
  img40840X: {
    [Setting.Theme.bakos]: img40840X_1,
    [Setting.Theme.cool]: img40840X_0,
    [Setting.Theme.plaster]: img40840X_2,
  },
  img50050X: {
    [Setting.Theme.bakos]: img50050X_1,
    [Setting.Theme.cool]: img50050X_0,
    [Setting.Theme.plaster]: img50050X_2,
  },
  img50250X: {
    [Setting.Theme.bakos]: img50250X_1,
    [Setting.Theme.cool]: img50250X_0,
    [Setting.Theme.plaster]: img50250X_2,
  },
  img50350X: {
    [Setting.Theme.bakos]: img50350X_1,
    [Setting.Theme.cool]: img50350X_0,
    [Setting.Theme.plaster]: img50350X_2,
  },
  img50450X: {
    [Setting.Theme.bakos]: img50450X_1,
    [Setting.Theme.cool]: img50450X_0,
    [Setting.Theme.plaster]: img50450X_2,
  },
  devprogressOthers: {
    [Setting.Theme.bakos]: devprogressOthers_1,
    [Setting.Theme.cool]: devprogressOthers_0,
    [Setting.Theme.plaster]: devprogressOthers_2,
  },
  notinserviceareaOthers: {
    [Setting.Theme.bakos]: notinserviceareaOthers_1,
    [Setting.Theme.cool]: notinserviceareaOthers_0,
    [Setting.Theme.plaster]: notinserviceareaOthers_2,
  },
  ['outright_' + SportIdMap.SOCCER]: {
    [Setting.Theme.bakos]: soccerBakosBlue,
    [Setting.Theme.cool]: soccerCoolBlack,
    [Setting.Theme.plaster]: soccerPlaster,
  },
  ['outright_' + SportIdMap.BASKETBALL]: {
    [Setting.Theme.bakos]: basketballBakosBlue,
    [Setting.Theme.cool]: basketballCoolBlack,
    [Setting.Theme.plaster]: basketballPlaster,
  },
  ['outright_' + SportIdMap.BASEBALL]: {
    [Setting.Theme.bakos]: baseballBakosBlue,
    [Setting.Theme.cool]: baseballCoolBlack,
    [Setting.Theme.plaster]: baseballPlaster,
  },
  ['outright_' + SportIdMap.ICE_HOCKEY]: {
    [Setting.Theme.bakos]: iceHockeyBakosBlue,
    [Setting.Theme.cool]: iceHockeyCoolBlack,
    [Setting.Theme.plaster]: iceHockeyPlaster,
  },
  ['outright_' + SportIdMap.TENNIS]: {
    [Setting.Theme.bakos]: tennisBakosBlue,
    [Setting.Theme.cool]: tennisCoolBlack,
    [Setting.Theme.plaster]: tennisPlaster,
  },
  ['outright_' + SportIdMap.HANDBALL]: {
    [Setting.Theme.bakos]: handballBakosBlue,
    [Setting.Theme.cool]: handballCoolBlack,
    [Setting.Theme.plaster]: handballPlaster,
  },
  ['outright_' + SportIdMap.GOLF]: {
    [Setting.Theme.bakos]: golfBakosBlue,
    [Setting.Theme.cool]: golfCoolBlack,
    [Setting.Theme.plaster]: golfPlaster,
  },
  ['outright_' + SportIdMap.RUGBY]: {
    [Setting.Theme.bakos]: rugbyBakosBlue,
    [Setting.Theme.cool]: rugbyCoolBlack,
    [Setting.Theme.plaster]: rugbyPlaster,
  },
  ['outright_' + SportIdMap.AUSSIE_RULES]: {
    [Setting.Theme.bakos]: aussieRulesBakosBlue,
    [Setting.Theme.cool]: aussieRulesCoolBlack,
    [Setting.Theme.plaster]: aussieRulesPlaster,
  },
  ['outright_' + SportIdMap.BANDY]: {
    [Setting.Theme.bakos]: bandyBakosBlue,
    [Setting.Theme.cool]: bandyCoolBlack,
    [Setting.Theme.plaster]: bandyPlaster,
  },
  ['outright_' + SportIdMap.AMERICAN_FOOTBALL]: {
    [Setting.Theme.bakos]: americanFootballBakosBlue,
    [Setting.Theme.cool]: americanFootballCoolBlack,
    [Setting.Theme.plaster]: americanFootballPlaster,
  },
  ['outright_' + SportIdMap.CYCLING]: {
    [Setting.Theme.bakos]: cyclingBakosBlue,
    [Setting.Theme.cool]: cyclingCoolBlack,
    [Setting.Theme.plaster]: cyclingPlaster,
  },
  ['outright_' + SportIdMap.SPECIALS]: {
    [Setting.Theme.bakos]: specialsBakosBlue,
    [Setting.Theme.cool]: specialsCoolBlack,
    [Setting.Theme.plaster]: specialsPlaster,
  },
  ['outright_' + SportIdMap.CRICKET]: {
    [Setting.Theme.bakos]: cricketBakosBlue,
    [Setting.Theme.cool]: cricketCoolBlack,
    [Setting.Theme.plaster]: cricketPlaster,
  },
  ['outright_' + SportIdMap.DARTS]: {
    [Setting.Theme.bakos]: dartsBakosBlue,
    [Setting.Theme.cool]: dartsCoolBlack,
    [Setting.Theme.plaster]: dartsPlaster,
  },
  ['outright_' + SportIdMap.VOLLEYBALL]: {
    [Setting.Theme.bakos]: volleyballBakosBlue,
    [Setting.Theme.cool]: volleyballCoolBlack,
    [Setting.Theme.plaster]: volleyballPlaster,
  },
  ['outright_' + SportIdMap.WATERPOLO]: {
    [Setting.Theme.bakos]: waterpoloBakosBlue,
    [Setting.Theme.cool]: waterpoloCoolBlack,
    [Setting.Theme.plaster]: waterpoloPlaster,
  },
  ['outright_' + SportIdMap.CURLING]: {
    [Setting.Theme.bakos]: curlingBakosBlue,
    [Setting.Theme.cool]: curlingCoolBlack,
    [Setting.Theme.plaster]: curlingPlaster,
  },
  ['outright_' + SportIdMap.FUTSAL]: {
    [Setting.Theme.bakos]: futsalBakosBlue,
    [Setting.Theme.cool]: futsalCoolBlack,
    [Setting.Theme.plaster]: futsalPlaster,
  },
  ['outright_' + SportIdMap.OLYMPICS]: {
    [Setting.Theme.bakos]: olympicsBakosBlue,
    [Setting.Theme.cool]: olympicsCoolBlack,
    [Setting.Theme.plaster]: olympicsPlaster,
  },
  ['outright_' + SportIdMap.LACROSSE]: {
    [Setting.Theme.bakos]: lacrosseBakosBlue,
    [Setting.Theme.cool]: lacrosseCoolBlack,
    [Setting.Theme.plaster]: lacrossePlaster,
  },
  ['outright_' + SportIdMap.FORMULA_1]: {
    [Setting.Theme.bakos]: formulaBakosBlue,
    [Setting.Theme.cool]: formulaCoolBlack,
    [Setting.Theme.plaster]: formulaPlaster,
  },
  ['outright_' + SportIdMap.ALPINE_SKIING]: {
    [Setting.Theme.bakos]: alpineSkiingBakosBlue,
    [Setting.Theme.cool]: alpineSkiingCoolBlack,
    [Setting.Theme.plaster]: alpineSkiingPlaster,
  },
  ['outright_' + SportIdMap.BIATHLON]: {
    [Setting.Theme.bakos]: biathlonBakosBlue,
    [Setting.Theme.cool]: biathlonCoolBlack,
    [Setting.Theme.plaster]: biathlonPlaster,
  },
  ['outright_' + SportIdMap.CROSS_COUNTRY]: {
    [Setting.Theme.bakos]: crossCountryBakosBlue,
    [Setting.Theme.cool]: crossCountryCoolBlack,
    [Setting.Theme.plaster]: crossCountryPlaster,
  },
  ['outright_' + SportIdMap.SKI_JUMPING]: {
    [Setting.Theme.bakos]: skiJumpingBakosBlue,
    [Setting.Theme.cool]: skiJumpingCoolBlack,
    [Setting.Theme.plaster]: skiJumpingPlaster,
  },
  ['outright_' + SportIdMap.ESPORT_COUNTER_STRIKE]: {
    [Setting.Theme.bakos]: eSportCounterStrikeBakosBlue,
    [Setting.Theme.cool]: eSportCounterStrikeCoolBlack,
    [Setting.Theme.plaster]: eSportCounterStrikePlaster,
  },
  ['outright_' + SportIdMap.ESPORT_DOTA]: {
    [Setting.Theme.bakos]: eSportDotaBakosBlue,
    [Setting.Theme.cool]: eSportDotaCoolBlack,
    [Setting.Theme.plaster]: eSportDotaPlaster,
  },
  ['outright_' + SportIdMap.ESPORT_CALL_OF_DUTY]: {
    [Setting.Theme.bakos]: eSportCallOfDutyBakosBlue,
    [Setting.Theme.cool]: eSportCallOfDutyCoolBlack,
    [Setting.Theme.plaster]: eSportCallOfDutyPlaster,
  },
  ['outright_' + SportIdMap.SPEEDWAY]: {
    [Setting.Theme.bakos]: speedwayBakosBlue,
    [Setting.Theme.cool]: speedwayCoolBlack,
    [Setting.Theme.plaster]: speedwayPlaster,
  },
  ['outright_' + SportIdMap.GAELIC_FOOTBALL]: {
    [Setting.Theme.bakos]: gaelicFootballBakosBlue,
    [Setting.Theme.cool]: gaelicFootballCoolBlack,
    [Setting.Theme.plaster]: gaelicFootballPlaster,
  },
  ['outright_' + SportIdMap.GAELIC_HURLING]: {
    [Setting.Theme.bakos]: gaelicHurlingBakosBlue,
    [Setting.Theme.cool]: gaelicHurlingCoolBlack,
    [Setting.Theme.plaster]: gaelicHurlingPlaster,
  },
  ['outright_' + SportIdMap.STOCK_CAR_RACING]: {
    [Setting.Theme.bakos]: stockCarRacingBakosBlue,
    [Setting.Theme.cool]: stockCarRacingCoolBlack,
    [Setting.Theme.plaster]: stockCarRacingPlaster,
  },
  ['outright_' + SportIdMap.ESPORT_VALORANT]: {
    [Setting.Theme.bakos]: eSportValorantBakosBlue,
    [Setting.Theme.cool]: eSportValorantCoolBlack,
    [Setting.Theme.plaster]: eSportValorantPlaster,
  },
  emptyEmptyimg: {
    [Setting.Theme.bakos]: emptyEmptyimg_1,
    [Setting.Theme.cool]: emptyEmptyimg_0,
    [Setting.Theme.plaster]: emptyEmptyimg_2,
  },
  Credit: {
    [Setting.Theme.bakos]: Credit3,
    [Setting.Theme.cool]: Credit1,
    [Setting.Theme.plaster]: Credit2,
  },
  BetBack: {
    [Setting.Theme.bakos]: BetBack,
    [Setting.Theme.cool]: BetBack,
    [Setting.Theme.plaster]: BetBack,
  },
  DedicatedHost: {
    [Setting.Theme.bakos]: DedicatedHost,
    [Setting.Theme.cool]: DedicatedHost,
    [Setting.Theme.plaster]: DedicatedHost,
  },
  MilestoneCash: {
    [Setting.Theme.bakos]: MilestoneCash,
    [Setting.Theme.cool]: MilestoneCash,
    [Setting.Theme.plaster]: MilestoneCash,
  },
  MonthlyRestock: {
    [Setting.Theme.bakos]: MonthlyRestock,
    [Setting.Theme.cool]: MonthlyRestock,
    [Setting.Theme.plaster]: MonthlyRestock,
  },
  ActionDrop: {
    [Setting.Theme.bakos]: ActionDrop,
    [Setting.Theme.cool]: ActionDrop,
    [Setting.Theme.plaster]: ActionDrop,
  },
  WeeklyEdge: {
    [Setting.Theme.bakos]: WeeklyEdge,
    [Setting.Theme.cool]: WeeklyEdge,
    [Setting.Theme.plaster]: WeeklyEdge,
  },
  Hero: {
    [Setting.Theme.bakos]: Hero,
    [Setting.Theme.cool]: Hero,
    [Setting.Theme.plaster]: Hero,
  },
  Bronze: {
    [Setting.Theme.bakos]: Bronze,
    [Setting.Theme.cool]: Bronze,
    [Setting.Theme.plaster]: Bronze,
  },
  Silver: {
    [Setting.Theme.bakos]: Silver,
    [Setting.Theme.cool]: Silver,
    [Setting.Theme.plaster]: Silver,
  },
  Gold: {
    [Setting.Theme.bakos]: Gold,
    [Setting.Theme.cool]: Gold,
    [Setting.Theme.plaster]: Gold,
  },
  Platinum: {
    [Setting.Theme.bakos]: Platinum,
    [Setting.Theme.cool]: Platinum,
    [Setting.Theme.plaster]: Platinum,
  },
  Diamond: {
    [Setting.Theme.bakos]: Diamond,
    [Setting.Theme.cool]: Diamond,
    [Setting.Theme.plaster]: Diamond,
  },
  Obsidian: {
    [Setting.Theme.bakos]: Obsidian,
    [Setting.Theme.cool]: Obsidian,
    [Setting.Theme.plaster]: Obsidian,
  },
  Init: {
    [Setting.Theme.bakos]: Init,
    [Setting.Theme.cool]: Init,
    [Setting.Theme.plaster]: Init,
  },
  UnlockActionDrop: {
    [Setting.Theme.bakos]: UnlockActionDrop,
    [Setting.Theme.cool]: UnlockActionDrop,
    [Setting.Theme.plaster]: UnlockActionDrop,
  },
  UnlockBetBack: {
    [Setting.Theme.bakos]: UnlockBetBack,
    [Setting.Theme.cool]: UnlockBetBack,
    [Setting.Theme.plaster]: UnlockBetBack,
  },
  UnlockDedicatedHost: {
    [Setting.Theme.bakos]: UnlockDedicatedHost,
    [Setting.Theme.cool]: UnlockDedicatedHost,
    [Setting.Theme.plaster]: UnlockDedicatedHost,
  },
  UnlockMilestoneCash: {
    [Setting.Theme.bakos]: UnlockMilestoneCash,
    [Setting.Theme.cool]: UnlockMilestoneCash,
    [Setting.Theme.plaster]: UnlockMilestoneCash,
  },
  UnlockMonthlyRestock: {
    [Setting.Theme.bakos]: UnlockMonthlyRestock,
    [Setting.Theme.cool]: UnlockMonthlyRestock,
    [Setting.Theme.plaster]: UnlockMonthlyRestock,
  },
  UnlockWeeklyEdge: {
    [Setting.Theme.bakos]: UnlockWeeklyEdge,
    [Setting.Theme.cool]: UnlockWeeklyEdge,
    [Setting.Theme.plaster]: UnlockWeeklyEdge,
  },
  HeroMaskBG: {
    [Setting.Theme.bakos]: HeroMaskBG,
    [Setting.Theme.cool]: HeroMaskBG,
    [Setting.Theme.plaster]: HeroMaskBG,
  },
  responsibleGamblingWallet: {
    [Setting.Theme.bakos]: FaqBakosBlue01,
    [Setting.Theme.cool]: FaqCoolBlack01,
    [Setting.Theme.plaster]: FaqPlaster01,
  },
  age18PlusWallet: {
    [Setting.Theme.bakos]: FaqBakosBlue02,
    [Setting.Theme.cool]: FaqCoolBlack02,
    [Setting.Theme.plaster]: FaqPlaster02,
  },
  cryptoGamblingFoundationWallet: {
    [Setting.Theme.bakos]: FaqBakosBlue03,
    [Setting.Theme.cool]: FaqCoolBlack03,
    [Setting.Theme.plaster]: FaqPlaster03,
  },
  iTechLabsWallet: {
    [Setting.Theme.bakos]: FaqBakosBlue04,
    [Setting.Theme.cool]: FaqCoolBlack04,
    [Setting.Theme.plaster]: FaqPlaster04,
  },
  ...matchDetailThemeAssets,
};

// Hook for getting theme-based assets
export const useSystemAssets = () => {
  return [
    new Proxy(
      {},
      {
        get(target, prop) {
          return themeAssets[prop as keyof typeof themeAssets]?.[setting.theme];
        },
      }
    ) as Record<keyof typeof themeAssets, string>,
    themeAssets,
  ] as const;
};
